import './Footer.css';

function Footer() {
  return (
    <footer className="text-center py-2">
      <span>&copy; {new Date().getFullYear()} OBRIY AI Sure®. All Rights Reserved.</span>
    </footer>
  );
}

export default Footer;
